<template>
  <transition name="slideFromBottom">
    <div v-if="isVisible" class="custom-cookie-consent" :class="position">
      <div class="cookie-content">
        <div class="cookie-message">
          <strong style="display: block; margin-bottom: 8px"
            >Cookie Notice</strong
          >
          We use cookies only to save authentication tokens and temporarily
          store content before displaying it in the application. These cookies
          are necessary for the proper functioning of our site.
        </div>
        <div class="cookie-buttons">
          <button @click="customize" class="customize-button">
            <span>Customize</span>
          </button>
          <button @click="reject" class="decline-button">
            <span>Reject All</span>
          </button>
          <button @click="accept" class="accept-button">
            <span>Accept All</span>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "CookieConsent",
  props: {
    position: {
      type: String,
      default: "bottom-left",
      validator: (value) =>
        ["bottom-left", "bottom-right", "top-left", "top-right"].includes(
          value
        ),
    },
    forceHide: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isVisible: false,
    };
  },
  watch: {
    // Add this watcher to respond to parent component changes
    forceHide(newVal) {
      if (newVal) {
        this.isVisible = false;
      }
    },
  },
  mounted() {
    // Check if consent cookie already exists
    const consentCookie = this.$cookies.get("cookie-consent");
    // Only show banner if consent hasn't been given yet
    this.isVisible = !consentCookie;
  },
  methods: {
    accept() {
      this.isVisible = false;
      this.$emit("accepted");
    },
    reject() {
      this.isVisible = false;
      this.$emit("declined");
    },
    customize() {
      this.$emit("customize");
    },
  },
};
</script>

<style scoped>
.custom-cookie-consent {
  position: fixed;
  z-index: 1000;
  padding: 15px;
  max-width: 600px;
}

.custom-cookie-consent.bottom-left {
  bottom: 20px;
  left: 20px;
}

.custom-cookie-consent.bottom-right {
  bottom: 20px;
  right: 20px;
}

.custom-cookie-consent.top-left {
  top: 20px;
  left: 20px;
}

.custom-cookie-consent.top-right {
  top: 20px;
  right: 20px;
}

.cookie-content {
  background-color: rgba(255, 255, 255);
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.cookie-message {
  font-size: 14px;
  color: #333;
  margin-bottom: 15px;
  line-height: 1.5;
}

.cookie-link {
  color: #0078d7;
  text-decoration: none;
  font-weight: 500;
  display: inline-block;
  margin-top: 5px;
}

.cookie-link:hover {
  text-decoration: underline;
}

.cookie-buttons {
  display: flex;
  justify-content: flex-end;
}

.cookie-buttons button {
  border: none;
  padding: 8px 16px;
  margin-left: 10px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.1s;
}

.accept-button {
  background-color: #0078d7;
  color: white;
}

.accept-button:hover {
  background-color: #43b882;
  transform: translateY(-1px);
}

.customize-button {
  background-color: rgba(255, 255, 255, 0.9);
  color: #555;
}

.customize-button:hover {
  background-color: #ebebeb;
  transform: translateY(-1px);
}

.decline-button {
  background-color: #f2f2f2;
  color: #555;
}

.decline-button:hover {
  background-color: #e45354;
  color: #fff;
  transform: translateY(-1px);
}

/* Animation */
.slideFromBottom-enter-active,
.slideFromBottom-leave-active {
  transition: transform 0.5s ease, opacity 0.5s ease;
}

.slideFromBottom-enter-from,
.slideFromBottom-leave-to {
  transform: translateY(30px);
  opacity: 0;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .custom-cookie-consent {
    max-width: 90%;
    margin: 0 auto;
    left: 0;
    right: 0;
  }

  .cookie-buttons button {
    padding: 8px 12px;
    font-size: 13px;
  }
}
</style>
